import { ButtonProps, Button as MantineButton } from '@mantine/core'

type Props = ButtonProps & {
  buttonType?: 'button' | 'submit' | 'reset' | undefined
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}

export const Button = ({ buttonType, ...rest }: Props) => (
  <MantineButton type={buttonType} {...rest} />
)
